import { render } from "./EditTextbookContents.vue?vue&type=template&id=62344046&scoped=true"
import script from "./EditTextbookContents.vue?vue&type=script&lang=js"
export * from "./EditTextbookContents.vue?vue&type=script&lang=js"

import "./EditTextbookContents.vue?vue&type=style&index=0&id=62344046&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62344046"]])

export default __exports__